export default {
  path: "/admin",
  component: () => import("@/views/organization-admin/LayoutView.vue"),
  children: [
    {
      path: "",
      redirect: "my",
    },
    {
      path: "my",
      props: {
        getDataUrl: "/my",
      },
      component: () => import("@/components/default/view/DefaultView.vue"),
    },
    {
      path: "mtb",
      props: {
        getDataUrl: "/mtb",
      },
      component: () => import("@/components/default/view/DefaultView.vue"),
    },
    {
      path: ":dir(staff)/(list)*",
      component: () => import("@/views/organization/staff/StaffList.vue"),
    },
    // {
    //     path: ':dir(group-gov)/(list)*',
    //     component: () => import('@/views/organization/group-gov/GroupGovList.vue')
    // },
    {
      path: ":dir(groupe)/view/:id(all)",
      component: () => import("@/components/default/view/DefaultView.vue"),
    },
    {
      path: ":dir(groupe)/view/:id",
      component: () => import("@/views/organization/groupView/GroupView.vue"),
    },
    {
      path: ":dir(place)/:subdir(submited)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=1",
      },
    },
    {
      path: ":dir(place)/:subdir(approved)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=2",
      },
    },
    {
      path: ":dir(place)/:subdir(rejected)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=3",
      },
    },
    {
      path: ":dir(place)/:subdir(revoked)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=4",
      },
    },
    {
      path: ":dir(journal)/view/:id",
      component: () => import("@/views/organization/journal/JournalView.vue"),
    },
    {
      path: ":dir(tickets)/view/:id",
      component: () => import("@/views/superadmin/ticket/TicketView.vue"),
    },
    {
      path: ":dir/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
    },
    {
      path: ":dir/view/:id",
      component: () => import("@/components/default/view/DefaultView.vue"),
    },
  ],
};
